export const getClubs = 'GET_CLUBS'
export const getAllClubs = 'GET_ALLCLUBS'
export const getTimeZones = 'GET_TIMEZONES'
export const getSettings = 'GET_SETTINGS'
export const getAllowedClubs = 'GET_ALLOWEDCLUBS'
export const getBranches = 'GET_BRANCHES'
export const getProductLevels = 'GET_PRODUCTLEVELS'
export const getAllBranches = 'GET_ALLBRANCHES'
export const getEnrollments = 'GET_ENROLLMENTS'
export const getLocations = 'GET_LOCATIONS'
export const getCostAdjustments = 'GET_COSTADJUSTMENTS'
export const getClub = 'GET_CLUB'
export const getBranch = 'GET_BRANCH'
export const getProductDetailTemplate = 'GET_PRODUCTDETAILTEMPLATE'
export const getProduct = 'GET_PRODUCT'
export const getLocation = 'GET_LOCATION'
export const getRoles = 'GET_ROLES'
export const getEnrollment = 'GET_ENROLLMENT'
export const getUser = 'GET_USER'
export const paginationLocation = 'SET_PAGINATION'
export const getCostAdjustment = 'GET_COSTADJUSTMENTS'
export const getStateProvinces = 'GET_STATEPROVINCES'
export const getEnrollmentUrl = 'GET_ENROLLMENT_URL'
export const updateClub = 'UPDATE_CLUB'
export const updateBranch = 'UPDATE_BRANCH'
export const updateProduct = 'UPDATE_PRODUCT'
export const updateLocation = 'UPDATE_LOCATION'
export const updateCostAdjustment = 'UPDATE_COSTADJUSTMENT'
export const updateEnrollment = 'UPDATE_ENROLLMENT'
export const updateUser = 'UPDATE_USER'
export const createClub = 'CREATE_CLUB'
export const createBranch = 'CREATE_BRANCH'
export const createProduct = 'CREATE_PRODUCT'
export const createLocation = 'CREATE_LOCATION'
export const createCostAdjustment = 'CREATE_COSTADJUSTMENT'
export const createUser = 'CREATE_USER'
export const updateResponse = 'UPDATE_RESPONSE'
export const userAuthentication = 'USER_AUTHENTICATION'
export const authenticationResponse = 'AUTHENTICATION_RESPONSE'
export const setAuthentication = 'SET_AUTHENTICATION'
export const setUnauthenticate = 'SET_UNAUTHENTICATE'
export const logOut = 'LOG_OUT'
export const silentLogOut = 'SILENT_LOG_OUT'
export const userResponse = 'USER_RESPONSE'
export const forgotPassword = 'FORGOT_PASSWORD'
export const validateSecureCode = 'VALIDATE_SECURE_CODE'
export const confirmChangePassword = 'CONFIRM_CHANGEPASSWORD'
export const currentNavigation = 'CURRENT_NAVIGATION'
export const getSales = 'GET_SALES'
export const getSale = 'GET_SALE'
export const addCharge = 'ADD_CHARGE'
export const addRefund = 'ADD_REFUND'
export const addRefundGift = 'ADD_REFUND_GIFT'
export const getRecipients = 'GET_RECIPIENTS'
export const getRecipient = 'GET_RECIPIENT'
export const getRecipientsPaginated = 'GET_RECIPIENTS_PAGINATED'
export const getRecipientsBySale = 'GET_RECIPIENTSBYSALE'
export const updateRecipient = 'UPDATE_RECIPIENT'
export const updateSale = 'UPDATE_SALE'
export const resendEmailRecipient = 'RESENDEMIAL_RECIPIENT'
export const resendEmailSale = 'RESENDEMAIL_SALE'
export const getProductHistoryById = 'GET_PRODUCTHISTORYBYID'
export const updateProductHistory = 'UPDATE_PRODUCTHISTORY'
export const updateRefund = 'UPDATE_REFUND'
export const sendToRouter = 'SEND_TO_ROUTER'
export const getPromoCode = 'GET_PROMOCODE'
export const getRedemptionGroups = 'GET_REDEMPTION_GROUPS'
export const getRedemptionCodes = 'GET_REDEMPTION_CODES'
export const getRedemptionClubs = 'GET_REDEMPTION_CLUBS'
export const getRedemptionBranches = 'GET_REDEMPTION_BRANCHES'
